import React, { useRef, useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: "#333333", // Solid color
        color: "#ffffff", // Text color
    },
    [`& .MuiTooltip-arrow`]: {
        color: "#333333", // Arrow color
    },
    [`& .MuiTooltip-tooltip div`]: {
        color: "#ffffff", // Ensure text inside div is white
    },
});

function Lesson({ done, children, hint, showAlert }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const contentRef = useRef(null);
    const [hasOverflow, setHasOverflow] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (contentRef.current) {
                const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
                setHasOverflow(hasOverflow);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [children]);

    var text;
    var severity;
    var icon;

    if (done) {
        text = "Task is done";
        severity = "success";
        icon = <CheckBoxOutlinedIcon />;
    } else {
        text = "Task is not done";
        severity = "info";
        icon = <CheckBoxOutlineBlankOutlinedIcon />;
    }

    return (
        <div className="lesson-container" style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            height: isMobile ? 'auto' : '526px' 
        }}>
            <div 
                ref={contentRef}
                style={{ 
                    flexGrow: 1,
                    overflowY: 'auto',
                    paddingRight: isMobile ? '0px' : (hasOverflow ? '16px' : '0px'),
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '4px',
                        '&:hover': {
                            background: '#555',
                        },
                    }
                }}
            >
                {children}
            </div>
            {showAlert && (
                <Alert 
                    variant="outlined" 
                    severity={severity}
                    icon={icon}
                    sx={{ 
                        '& .MuiAlert-icon': {
                            color: '#006666'
                        },
                        borderColor: '#006666',
                        display: 'flex',
                        alignItems: 'center',
                        '& .MuiAlert-message': {
                            flex: 1
                        },
                        marginTop: isMobile ? '0px' : (hasOverflow ? '16px' : '0px'),
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <span style={{ marginRight: '8px' }}>{text}</span>
                        <div style={{ flexGrow: 1 }}></div>
                        {hint && (
                            <CustomTooltip 
                                title={
                                    <React.Fragment>
                                        <div>{hint}</div>
                                    </React.Fragment>
                                }
                                arrow
                            >
                                <HelpOutlineIcon style={{ color: '#006666' }} />
                            </CustomTooltip>
                        )}
                    </div>
                </Alert>
            )}
        </div>
    );
}

export default Lesson;